import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanDeactivate,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { DigiAIXCoreAppState } from '../app-state';
import { HideSideBar } from './actions/side-bar.actions';

/**
 * @deprecated use data property instead
 */
@Injectable({
  providedIn: 'root',
})
export class ForceHideSidebarGuard<AppState extends DigiAIXCoreAppState>
  implements CanActivate, CanActivateChild, CanDeactivate<any> {
  constructor(public store$: Store<AppState>) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    this.store$.dispatch(new HideSideBar());
    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    return this.canActivate(childRoute, state);
  }

  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): boolean {
    return this.canActivate(currentRoute, currentState);
  }
}
